import { getRequest, postRequest, putRequest } from "../services/apiHelpers";

export const postAdvisory = async (payload) => {
  try {
    const res = await postRequest({ url: "/advisories", payload: payload });
    return res;
  } catch (e) {
    throw e;
  }
};

export const putAdvisory = async ({ id, payload }) => {
  try {
    const res = await putRequest({
      url: "/advisories",
      query: { advisory_id: id },
      payload: payload,
    });
    return res;
  } catch (e) {
    throw e;
  }
};

export const getAdvisories = async (query) => {
  try {
    const res = await getRequest({
      url: "/advisories",
      query: query,
    });
    return res;
  } catch (e) {
    throw e;
  }
};
